/* CLIENT EDITOR */
Vue.component('clienteditor',{
    template:'#clienteditor-template',
    data:function(){
        return{
            client: [],
            activeTab:'personaldata',
            backupRecord:[],
            password:'',
            password_verify:'',
            passwordFieldIsActive:false,
            brands:[],
            subBrands:[],
            activeClient:'',
            activeBrand:'',
            activeBrandId:'',
            activeSubBrand:'',
            activeSubBrandId:'',
            projectName:'',
            projectDeadLine:'',
            projectStart:''
        };
    },
    created:function(){
        activeInstance = this;
        

        setTimeout(function(){
            $(function () {
                $('#datetimepicker5').datetimepicker({
                    format: 'YYYY-MM-DD HH:mm',
                    locale: 'hu'
                });
                $('#datetimepicker6').datetimepicker({
                    format: 'YYYY-MM-DD HH:mm',
                    locale: 'hu'
                });

            });
        },300);

        this.fetchData();

    },
    events: {
        //ON CLIENT SELECTION
        'autocomplete-result:selected': function(data){
            //console.log(data);
            activeInstance.activeClient = data;
            activeInstance.getClientBrands(data.id);
        }
    },
    methods:{
        fetchData: function() {
            var id = $('#content_wrapper').attr('data-id');

            showLoadingOverlay();
            Vue.http.get(baseURL+'/api/client/list/'+id).then(function(response){
                $('body').LoadingOverlay("hide");
                activeInstance.client = response.data;
                activeInstance.getClientBrands(response.data[0].id);
            }).bind(this);
        },
        requestProjectNumber:function(){
            var validation = true;
            if(validation == true){

                bootbox.confirm('Minden adat helyes?', function(value){
                    if(value==true){
                        showLoadingOverlay();
                        Vue.http.post(baseURL+'/admin/createProjectNumber', {'client_id':activeInstance.activeClient.id, name:activeInstance.projectName, brand_id:activeInstance.activeBrandId,sub_brand_id:activeInstance.activeSubBrandId, start:activeInstance.projectStart,deadline:activeInstance.projectDeadLine}).then(function(response){
                            $('body').LoadingOverlay("hide");
                            successNotification('A projekt elkészült.');

                        }).bind(this);

                    }
                });
            }
        },
        createBrand: function() {
            vex.dialog.prompt({
                message: 'Új márka hozzáadása',
                placeholder: 'Márka neve',
                callback: function (value) {
                    var client_id = activeInstance.client[0].id;
                    var brand_name = value;

                    if (!brand_name || brand_name.trim().length < 1) {
                        return false;
                    }

                    axios.post(baseURL+'/admin/brand/add', {
                        client_id: client_id,
                        name: brand_name,
                    }).then(function(response){
                        successNotification('A márka sikeresen hozzáadva');
                        activeInstance.getClientBrands(client_id);
                    });
                }
            });
        },
        createSubBrand: function(brand_id) {
            vex.dialog.prompt({
                message: 'Új almárka hozzáadása',
                placeholder: 'Almárka neve',
                callback: function (value) {
                    var client_id = activeInstance.client[0].id;
                    var sub_brand_name = value;

                    if (!sub_brand_name || sub_brand_name.trim().length < 1) {
                        return false;
                    }

                    axios.post(baseURL+'/admin/sub_brand/add', {
                        id: brand_id,
                        name: sub_brand_name,
                    }).then(function(response){
                        successNotification('Az almárka sikeresen hozzáadva');
                        activeInstance.getClientBrands(client_id);
                    });
                }
            });
        },
        updateBrand: function(brand) {
            vex.dialog.prompt({
                message: 'Márka módosítása',
                placeholder: 'Márka neve',
                value: brand.name,
                callback: function (value) {
                    var brand_name = value;

                    if (!brand_name || brand_name.trim().length < 1) {
                        return false;
                    }

                    axios.post(baseURL+'/admin/brand/update', {
                        id: brand.id,
                        name: brand_name,
                    }).then(function(response) {
                        brand.name = brand_name;
                        successNotification('A márka sikeresen módosítva');
                    });
                }
            });
        },
        updateSubBrand: function(sub_brand) {
            vex.dialog.prompt({
                message: 'Almárka módosítása',
                value: sub_brand.name,
                placeholder: 'Almárka neve',
                callback: function (value) {
                    var sub_brand_name = value;

                    if (!sub_brand_name || sub_brand_name.trim().length < 1) {
                        return false;
                    }

                    axios.post(baseURL+'/admin/sub_brand/update', {
                        id: sub_brand.id,
                        name: sub_brand_name,
                    }).then(function(response){
                        sub_brand.name = sub_brand_name;
                        successNotification('Az almárka sikeresen módosítva');
                    });
                }
            });
        },
        removeBrand: function(brand, index) {
            vex.dialog.confirm({
                message: 'Biztosan törölni szeretnéd a márkát?',
                callback: function (value) {
                    if (value) {
                        axios.post(baseURL+'/admin/brand/destroy', {
                            id: brand.id,
                        }).then(function(response) {
                            //brand.name = brand_name;
                            if (response.data.code == 200) {
                                activeInstance.brands.splice(index, 1);
                                successNotification(response.data.message);
                            } else {
                                errorNotification(response.data.message);
                            }
                        }).catch(function(response) {
                            console.log(response);
                            //errorNotification(response.data.message);
                        });
                    }
                }
            })
        },
        removeSubBrand: function(sub_brand) {
            vex.dialog.prompt({
                message: 'Almárka módosítása',
                value: sub_brand.name,
                placeholder: 'Almárka neve',
                callback: function (value) {
                    var sub_brand_name = value;

                    if (!sub_brand_name || sub_brand_name.trim().length < 1) {
                        return false;
                    }

                    axios.post(baseURL+'/admin/sub_brand/update', {
                        id: sub_brand.id,
                        name: sub_brand_name,
                    }).then(function(response){
                        sub_brand.name = sub_brand_name;
                        successNotification('Az almárka sikeresen módosítva');
                    });
                }
            });
        },
        //GET BRANDS BELONGS TO A CLIENT
        getClientBrands:function(id){
            activeInstance.$http.get(baseURL+'/api/brand/list/all/'+id).then(function(response){
                activeInstance.brands = response.data;
            }).bind(this);
        },
        //GET SUB BRANDS BELONGS TO A BRAND
        getBrandSubBrands:function(event,data){

            $.each(activeInstance.brands, function(index,brand){
                console.log('searching...');

                if(brand.id==activeInstance.activeBrandId){
                    console.log('found...');
                    activeInstance.activeBrand = brand;
                }
            });

            activeInstance.$http.get(baseURL+'/api/sub_brand/list/brand/'+activeInstance.activeBrand.id).then(function(response){
                activeInstance.subBrands = response.data;
            }).bind(this);

        },
        setActiveSubBrand:function(event){
            var subBrandId = $(event.target).val();
            $.each(activeInstance.subBrands, function(index,sub_brand){
                console.log('searching...');

                if(sub_brand.id==subBrandId){
                    console.log('found...');
                    activeInstance.activeSubBrand = sub_brand;
                }
            });
        },
        checkPassword:function(){

            re = /^\w+$/;
            if(activeInstance.password != "" && activeInstance.password == activeInstance.password_verify) {
                if(activeInstance.password.length < 6) {
                    errorNotification("Hiba: A jelszónak legalább 6 karakter hosszúnak kell lennie!");
                    return false;
                }
                re = /[0-9]/;
                if(!re.test(activeInstance.password)) {
                    errorNotification("Hiba: A jelszóban legalább egy számnak szerepelnie kell!");
                    return false;
                }
                re = /[a-z]/;
                if(!re.test(activeInstance.password)) {
                    errorNotification("Hiba: A jelszóban legalább egy kisbetűnek szerepelnie kell (a-z)!");
                    return false;
                }
                re = /[A-Z]/;
                if(!re.test(activeInstance.password)) {
                    errorNotification("Hiba: A jelszóban legalább egy nagybetűnek szerepelnie kell (A-Z)!");
                    return false;
                }
            }
            else {
                if(activeInstance.password==""){
                    errorNotification("Hiba: A jelszó nincs kitöltve");
                    return false;
                }
                else{
                    errorNotification("Hiba: A jelszó nem egyezik a megerősítéssel.");
                    return false;
                }

            }
            return true;
        },
        togglePasswordField:function(){
            if(activeInstance.passwordFieldIsActive == true){
                activeInstance.passwordFieldIsActive = false;
            }
            else{
                activeInstance.passwordFieldIsActive = true;
            }
        },
        updateclientPassword:function(){
            var validated = activeInstance.checkPassword();
            if(validated == true){
                bootbox.confirm('Biztosan mented az új jelszót?', function(value){
                    if(value==true){
                        showLoadingOverlay();
                        Vue.http.post(baseURL+'/admin/client/update/password', {'client':activeInstance.client,'password':activeInstance.password}).then(function(response){
                            $('body').LoadingOverlay("hide");
                            successNotification('Jelszó sikeresen frissítve');
                        }).bind(this);
                    }
                });
            }
        },
        updateclientNameAndEmail:function(){
            bootbox.confirm('Biztosan mented az új jelszót?', function(value){
                if(value==true){
                    showLoadingOverlay();
                    Vue.http.post(baseURL+'/admin/client/update/name_and_email', {'client':activeInstance.client,'password':activeInstance.password}).then(function(response){
                        $('body').LoadingOverlay("hide");
                        successNotification('Jelszó sikeresen frissítve');
                    }).bind(this);
                }
            });
        },
        toggleShippingRecordLock:function(record){

            if(record.locked==false){
                record.locked=true;
            }else{
                record.backup =  JSON.parse( JSON.stringify( record ) );
                record.locked=false;
            }

        },
        togglePersonalRecordLock:function(record){

            if(record.locked==false){
                record.locked=true;
            }else{
                record.backup =  JSON.parse( JSON.stringify( record ) );
                record.locked=false;
            }

        },
        toggleInvoiceRecordLock:function(record){

            if(record.locked==false){
                record.locked=true;
            }else{
                record.backup =  JSON.parse( JSON.stringify( record ) );
                record.locked=false;
            }

        },
        cancelPersonalEdit:function(record){
            record.firstname = record.backup.firstname;
            record.postcode = record.backup.postcode;
            record.town = record.backup.town;
            record.street = record.backup.street;
            record.floor_door = record.backup.floor_door;
            record.phone = record.backup.phone;
            record.locked=1;
        },
        cancelShippingEdit:function(record){
            record.firstname = record.backup.firstname;
            record.postcode = record.backup.postcode;
            record.town = record.backup.town;
            record.street = record.backup.street;
            record.floor_door = record.backup.floor_door;
            record.phone = record.backup.phone;
            record.locked=1;
        },
        cancelInvoiceEdit:function(record){
            record.firstname = record.backup.firstname;
            record.postcode = record.backup.postcode;
            record.town = record.backup.town;
            record.street = record.backup.street;
            record.floor_door = record.backup.floor_door;
            record.phone = record.backup.phone;
            record.locked=1;
        },
        updatePersonalRecord:function(record){
            showLoadingOverlay();
            Vue.http.post(baseURL+'/admin/address/update',{record:record, type:"personal"}).then(function(response){
                //console.log(response);
                $('body').LoadingOverlay("hide");
                successNotification('Sikeres mentés');
            });
        },
        updateShippingRecord:function(record){
            showLoadingOverlay();
            Vue.http.post(baseURL+'/admin/address/update',{record:record, type:"shipping"}).then(function(response){
                $('body').LoadingOverlay("hide");
                //console.log(response);
                successNotification('Sikeres mentés');
            });
        },
        updateInvoiceRecord:function(record){
            showLoadingOverlay();
            Vue.http.post(baseURL+'/admin/address/update',{record:record, type:"invoice"}).then(function(response){
                $('body').LoadingOverlay("hide");
                //console.log(response);
                successNotification('Sikeres mentés');
                record.locked=true;
            });
        },
        //DESTROY
        deleteShippingRecord:function(record){

            bootbox.confirm('Biztosan el akarod távolítani ezt a címet?', function(value){
                if(value==true){
                    showLoadingOverlay();
                    Vue.http.post(baseURL+'/admin/address/delete', {record:record, type:"shipping"}).then(function(response){
                        $('body').LoadingOverlay("hide");
                        activeInstance.client[0].shippingdata.$remove(record);
                        successNotification('Sikeres törlés');
                    }).bind(this);
                }
            });

        },
        deleteInvoiceRecord:function(record){
            bootbox.confirm('Biztosan el akarod távolítani ezt a címet?', function(value){
                if(value==true){
                    showLoadingOverlay();
                    Vue.http.post(baseURL+'/admin/address/delete', {record:record, type:"invoice"}).then(function(response){
                        $('body').LoadingOverlay("hide");
                        activeInstance.client[0].invoicedata.$remove(record);
                        successNotification('Sikeres törlés');
                    }).bind(this);
                }
            });
        },
        validateForm:function(){
            var form_is_valid = true;
            $('.error').removeClass('error');

            //EMAIL
            if(validateEmail(activeInstance.client[0].email) == false) {
                errorNotification('Az email cím nem érvényes.');
                $('#email').addClass('error');
                form_is_valid = false;
            }

            //SHORTCODE
            if( activeInstance.client[0].short_code.length<1 |  activeInstance.client[0].short_code.length > 7 || activeInstance.client[0].short_code.indexOf(' ') > 0) {
                errorNotification('Az ügyfél cégnév kód nem érvényes. (Mimimum 1, maximum 6 karakteres, szóközök nélküli karaktelánc.)');
                $('#short_code').addClass('error');
                form_is_valid = false;
            }
            return form_is_valid;

        },
        save:function(){
            var form_is_valid = activeInstance.validateForm();
            if( form_is_valid == true){
                showLoadingOverlay();
                Vue.http.post(baseURL+'/admin/client/update',{client:activeInstance.client[0]}).then(function(response){
                    $('body').LoadingOverlay("hide");

                    successNotification('Sikeres mentés');
                    setTimeout(function(){
                        location.href=baseURL+"/admin/clients";
                    },600);
                });
            }
        }
    }
});